import model from '../models-v2/invoice/payment-due';

export default [
  {
    path: '/invoices/payment-due',
    name: 'invoices-payment-due',
    components: {
      default: () => import('../views/pages/invoices/payment-due/ListView.vue'),
      topRightSection: () => import('../views/pages/invoices/components/PaymentDueTopRightSection.vue'),
    },
    meta: {
      breadcrumb: [
        { title: 'Fakturowanie', url: '/invoices/payment-due' },
        { title: 'Należności', url: '/invoices/payment-due' },
      ],
      paginationGroupName: 'invoices-index',
      module: 'INVOICES',
      model: 'invoice',
      search: true,
    },
    props: {
      default: (props) => ({ ...props, model }),
      topRightSection: (props) => ({ ...props, actions: model.topRightActions }),
    },
  },
];
